import Link from 'next/link';

import {
  List,
  ListItem,
  ListItemAvatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useMediaQuery,
  NoSsr,
  Avatar,
  ListItemText,
} from '@material-ui/core';
import { useTheme, makeStyles } from '@material-ui/core/styles';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

import clsx from 'clsx';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  dialog: {
    borderTop: `8px transparent solid`,
    [theme.breakpoints.up('sm')]: {
      borderRadius: theme.spacing(2),
    },
  },
  button: {
    marginRight: theme.spacing(2),
  },
  dialogContent: {
    padding: 0,
  },
  dialogContentText: {
    padding: theme.spacing(2),
  },
}));

function Menu(props) {
  const { open, onClose, className, title, subtitle, options, AvatarProps, demoHref, loginHref } =
    props;

  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={onClose}
      PaperProps={{ className: clsx(className, classes.dialog) }}
      aria-labelledby="responsive-dialog-title">
      <DialogTitle id="responsive-dialog-title">{title}</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <DialogContentText className={classes.dialogContentText}>{subtitle}</DialogContentText>
        <List>
          {options?.map((item, index) => (
            <Link href={item.href} passHref key={index.toString()}>
              <ListItem button component="a" divider={index < options.length}>
                <ListItemAvatar>
                  <Avatar className={AvatarProps?.className}>
                    <NoSsr>
                      <i className={item.icon} />
                    </NoSsr>
                  </Avatar>
                </ListItemAvatar>
                <ListItemText>{item.label}</ListItemText>
                <NavigateNextIcon color="action" />
              </ListItem>
            </Link>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        {demoHref && (
          <Link href={demoHref} passHref>
            <Button
              aria-label="Agendar"
              autoFocus
              onClick={onClose}
              color="inherit"
              component="a"
              className={classes.button}
              target="_blank"
              rel="noopener noreferrer">
              Agendar
            </Button>
          </Link>
        )}
        <Button onClick={onClose} color="inherit" className={classes.button} aria-label="Fechar">
          Fechar
        </Button>
        <Link href={loginHref} passHref>
          <Button
            aria-label="Entrar"
            className={AvatarProps?.className}
            variant="contained"
            onClick={onClose}
            color="primary"
            component="a"
            target="_blank">
            Entrar
          </Button>
        </Link>
      </DialogActions>
    </Dialog>
  );
}

Menu.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  className: PropTypes.any,
  title: PropTypes.any,
  subtitle: PropTypes.any,
  demoHref: PropTypes.any,
  loginHref: PropTypes.any,
  options: PropTypes.array,
  AvatarProps: PropTypes.object,
};

export default Menu;
